import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { ListItem } from '@material-ui/core';
import styles from './ValidationListItem.module.css';

const ValidationListItem = ({ valid, text }) => (
  <ListItem className={classNames({ [styles.itemValid]: valid })}>
    <div className={classNames(styles.dot)} />
    <span className={styles.text}>{text}</span>
  </ListItem>
);
ValidationListItem.propTypes = {
  text: propTypes.string,
  valid: propTypes.bool,
};
ValidationListItem.defaultProps = {
  text: '',
  valid: false,
};
export default ValidationListItem;
